export default __webpack_public_path__ + "static/media/Head_3_Ear_1_C1.307f67d8.svg";